import Vue from 'vue'
import {
  ToastPlugin,
  ModalPlugin,
  FormInputPlugin,
  FormSelectPlugin,
  InputGroupPlugin,
  FormCheckboxPlugin,
  FormTextareaPlugin,
  PaginationPlugin,
  CardPlugin,
  BadgePlugin,
} from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueMoment from 'vue-moment'
import 'vue-toastification/dist/index.css'
import router from './router'
import store from './store'
import App from './App.vue'
import { permissionAbility } from '@/helpers/helpers'

// To show toaster
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'

//// Pusher
import { pusherChannel, pusherAppKey } from '../pusher-config.js'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'

// helpers
import axios from '@/helpers/axios'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormSelectPlugin)
Vue.use(InputGroupPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(FormTextareaPlugin)
Vue.use(PaginationPlugin)
Vue.use(CardPlugin)
Vue.use(BadgePlugin)

// Composition API
Vue.use(VueCompositionAPI)

// global filter
// time formatter
Vue.use(VueMoment)

// API base URL comes from .env.production as the single source of truth.
const envApiBaseURL = (process.env.VUE_APP_API_URL || '').replace(/\/$/, '')

axios.defaults.baseURL = envApiBaseURL || `${window.location.origin}/api`

// global axios
Vue.prototype.$api = axios
// permissionAbility
Vue.prototype.$permissionAbility = permissionAbility

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
